import { customPayrollTypes } from '../types/customPayrollTypes';
import { resolvePositionRatesAndRefs } from '../../Pages/CustomPayroll/customPayrollInfoHelpers';

const initialState = {
  employeesInCustomPayroll: [],
  payrollEntityList: [],
  deletedItems: []
};

export const customPayrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case customPayrollTypes.ADD_EMPLOYEE_IN_CUSTOMPAYROLL: {
      const updatedEmployees = [...state.employeesInCustomPayroll, action.payload];

      updatedEmployees.sort((a, b) => {
        const lastNameComparison = a.lastName.localeCompare(b.lastName);
        if (lastNameComparison !== 0) {
          return lastNameComparison;
        }
        return a.firstName.localeCompare(b.firstName);
      });

      return {
        ...state,
        employeesInCustomPayroll: updatedEmployees
      };
    }

    case customPayrollTypes.ADD_CUSTOM_PAYROLL: {
      const updatedPayrollList = state.payrollEntityList.map((payroll) => ({
        ...payroll,
        ...action.payload
      }));
      return {
        ...state,
        payrollEntityList: updatedPayrollList
      };
    }

    case customPayrollTypes.ADD_CUSTOM_PAYROLL_LIST: {
      const newEntries = action.payload;
      const updatedList = [...state.payrollEntityList, ...newEntries];
      return {
        ...state,
        payrollEntityList: updatedList
      };
    }

    case customPayrollTypes.ADD_SAME_DATA_CUSTOM_PAYROLL: {
      const updatedPayrollEntityList = state.employeesInCustomPayroll.map((employee) => {
        const { personId } = employee;
        const updatedPayload = {
          ...action.payload,
          id: personId,
          person: { personId }
        };
        return updatedPayload;
      });
      const employeesInCustomPayrollSame = state.employeesInCustomPayroll.map((employee) => {
        const customSame = state.payrollEntityList.filter((item) => item.id !== employee.personId);
        return {
          ...employee,
          confirmation: customSame.length >= 1
        };
      });

      return {
        ...state,
        payrollEntityList: [...state.payrollEntityList, ...updatedPayrollEntityList],
        employeesInCustomPayroll: employeesInCustomPayrollSame
      };
    }

    case customPayrollTypes.DELETE_CUSTOM_PAYROLL: {
      const idsToDelete = action.payload.ids.map(Number);

      const updatedEmployeesInCustomPayroll = state.employeesInCustomPayroll.filter((employee) => {
        const shouldDelete = idsToDelete.includes(Number(employee.personId));
        return !shouldDelete;
      });

      const newListCustomPayroll = state.payrollEntityList.filter((item) => {
        const shouldDelete = idsToDelete.includes(Number(item.personId));
        return !shouldDelete;
      });

      const deletedItems = state.payrollEntityList.filter((item) => {
        const shouldDelete = idsToDelete.includes(Number(item.personId));
        return shouldDelete;
      });

      return {
        ...state,
        employeesInCustomPayroll: updatedEmployeesInCustomPayroll,
        payrollEntityList: newListCustomPayroll,
        deletedItems: [...state.deletedItems, ...deletedItems]
      };
    }

    case customPayrollTypes.REMOVE_EMPLOYEE_IN_CUSTOMPAYROLL: {
      const { _id, label } = action.payload;

      return {
        ...state,
        employeesInCustomPayroll: state.employeesInCustomPayroll.map((employee) => {
          if (employee.id === _id) {
            const update = {
              ...employee
            };
            if (label === 'labelBill') {
              update.deleteBill = true;
            } else if (label === 'labelPay') {
              update.deletePay = true;
            }
            return update;
          }

          return employee;
        }),
        payrollEntityList: state.payrollEntityList.map((employee) => {
          if (employee.id === _id) {
            const update = {
              ...employee
            };

            if (label === 'labelBill') {
              update.amountBill = null;
              update.hoursBill = null;
              update.billingCode = null;
              update.deleteBill = true;
            } else if (label === 'labelPay') {
              update.amountPay = null;
              update.hoursPay = null;
              update.payCode = null;
              update.deletePay = true;
            }

            return {
              ...employee,
              ...update
            };
          }
          return employee;
        })
      };
    }

    case customPayrollTypes.UPDATE_CUSTOM_PAYROLL_ENTRY: {
      const updatedEntry = action.payload;
      const existingEntryIndex = state.payrollEntityList.findIndex(
        (entry) => entry.id === updatedEntry.id && entry._idHeader === updatedEntry._idHeader
      );

      const deepCopyNestedObjects = (entry) => {
        const copy = { ...entry };
        if (copy.payCode && typeof copy.payCode === 'object') {
          copy.payCode = { ...copy.payCode };
        }
        if (copy.billingCode && typeof copy.billingCode === 'object') {
          copy.billingCode = { ...copy.billingCode };
        }
        if (copy.person && typeof copy.person === 'object') {
          copy.person = { ...copy.person };
        }
        if (copy.department && typeof copy.department === 'object') {
          copy.department = { ...copy.department };
        }
        if (copy.position && typeof copy.position === 'object') {
          copy.position = { ...copy.position };
        }
        return copy;
      };

      let updatedPayrollEntityList;

      if (existingEntryIndex !== -1) {
        const existingEntry = state.payrollEntityList[existingEntryIndex];

        const existingEntryCopy = deepCopyNestedObjects(existingEntry);
        const updatedEntryCopy = deepCopyNestedObjects(updatedEntry);

        const mergedEntry = {
          ...existingEntryCopy,
          ...updatedEntryCopy
        };
        updatedPayrollEntityList = [
          ...state.payrollEntityList.slice(0, existingEntryIndex),
          mergedEntry,
          ...state.payrollEntityList.slice(existingEntryIndex + 1)
        ];
      } else {
        const newEntry = deepCopyNestedObjects(updatedEntry);
        updatedPayrollEntityList = [...state.payrollEntityList, newEntry];
      }

      return {
        ...state,
        payrollEntityList: updatedPayrollEntityList
      };
    }

    case customPayrollTypes.BATCH_UPDATE_CUSTOM_PAYROLL_ENTRIES: {
      const updatedEntries = action.payload;

      const deepCopyNestedObjects = (entry) => {
        const copy = { ...entry };
        if (copy.payCode && typeof copy.payCode === 'object') {
          copy.payCode = { ...copy.payCode };
        }
        if (copy.billingCode && typeof copy.billingCode === 'object') {
          copy.billingCode = { ...copy.billingCode };
        }
        if (copy.person && typeof copy.person === 'object') {
          copy.person = { ...copy.person };
        }
        if (copy.department && typeof copy.department === 'object') {
          copy.department = { ...copy.department };
        }
        if (copy.position && typeof copy.position === 'object') {
          copy.position = { ...copy.position };
        }
        return copy;
      };

      // Create a map of existing entries for fast lookup
      const existingEntriesMap = new Map();
      state.payrollEntityList.forEach((entry, index) => {
        const key = `${entry.id}-${entry._idHeader}`;
        existingEntriesMap.set(key, { entry, index });
      });

      // Process all updates in a single pass
      const updatedPayrollEntityList = [...state.payrollEntityList];
      const processedIndices = new Set();

      updatedEntries.forEach((updatedEntry) => {
        const key = `${updatedEntry.id}-${updatedEntry._idHeader}`;
        const existing = existingEntriesMap.get(key);

        if (existing && !processedIndices.has(existing.index)) {
          const existingEntryCopy = deepCopyNestedObjects(existing.entry);
          const updatedEntryCopy = deepCopyNestedObjects(updatedEntry);

          // Direct merge: updatedEntryCopy completely overwrites existingEntryCopy
          // This ensures that hoursPay, amountPay, hoursBill, amountBill are copied exactly as they are
          const mergedEntry = {
            ...existingEntryCopy,
            ...updatedEntryCopy
          };

          // Explicitly set the fields we care about (even if they are undefined/null)
          // This ensures the copy operation works correctly
          if ('hoursPay' in updatedEntryCopy) {
            mergedEntry.hoursPay = updatedEntryCopy.hoursPay;
          }
          if ('amountPay' in updatedEntryCopy) {
            mergedEntry.amountPay = updatedEntryCopy.amountPay;
          }
          if ('hoursBill' in updatedEntryCopy) {
            mergedEntry.hoursBill = updatedEntryCopy.hoursBill;
          }
          if ('amountBill' in updatedEntryCopy) {
            mergedEntry.amountBill = updatedEntryCopy.amountBill;
          }
          if ('payCode' in updatedEntryCopy) {
            mergedEntry.payCode = updatedEntryCopy.payCode;
          }
          if ('billingCode' in updatedEntryCopy) {
            mergedEntry.billingCode = updatedEntryCopy.billingCode;
          }
          // payRate y billRate siempre deben ir en cada entrada; no eliminarlos si el update trae undefined
          const hasPayRate = updatedEntryCopy.payRate != null && updatedEntryCopy.payRate !== '';
          const hasBillRate = updatedEntryCopy.billRate != null && updatedEntryCopy.billRate !== '';
          mergedEntry.payRate = hasPayRate ? updatedEntryCopy.payRate : (existingEntryCopy.payRate ?? updatedEntryCopy.payRate);
          mergedEntry.billRate = hasBillRate ? updatedEntryCopy.billRate : (existingEntryCopy.billRate ?? updatedEntryCopy.billRate);
          if ('modified' in updatedEntryCopy) {
            mergedEntry.modified = updatedEntryCopy.modified;
          }

          updatedPayrollEntityList[existing.index] = mergedEntry;
          processedIndices.add(existing.index);
        } else if (!existing) {
          // Add new entry if it doesn't exist - garantizar que tenga payRate y billRate
          const newEntry = deepCopyNestedObjects(updatedEntry);
          // Si faltan rates, buscarlos del empleado
          if (!newEntry.payRate || !newEntry.billRate) {
            const employee = state.employeesInCustomPayroll.find(
              (emp) => emp.id === updatedEntry.id || emp.personId === updatedEntry.personId
            );
            if (employee) {
              if (!newEntry.payRate) newEntry.payRate = employee.rate ?? null;
              if (!newEntry.billRate) newEntry.billRate = employee.bill ?? null;
            }
          }
          updatedPayrollEntityList.push(newEntry);
        }
      });

      return {
        ...state,
        payrollEntityList: updatedPayrollEntityList
      };
    }

    case customPayrollTypes.ADD_CUSTOM_PAYROLL_FOR_ALL_EMPLOYEES: {
      const entries = action.payload;

      const updatedPayrollEntityList = [...state.payrollEntityList];

      entries.forEach((customPayroll) => {
        state.employeesInCustomPayroll.forEach((employee) => {
          const payRate = employee?.rate;
          const billRate = employee?.bill;

          const existingIndex = updatedPayrollEntityList.findIndex(
            (item) => item.id === employee.id && item._idHeader === customPayroll._idHeader
          );

          if (existingIndex !== -1) {
            const existingEntry = updatedPayrollEntityList[existingIndex];

            // Garantizar que payRate y billRate siempre existan (del empleado si faltan)
            const finalPayRate = existingEntry.payRate ?? payRate ?? null;
            const finalBillRate = existingEntry.billRate ?? billRate ?? null;

            const updatedEntry = {
              ...existingEntry,

              ...(customPayroll.amountPay !== undefined && { amountPay: customPayroll.amountPay }),
              ...(customPayroll.hoursPay !== undefined && { hoursPay: customPayroll.hoursPay }),
              ...(customPayroll.amountBill !== undefined && { amountBill: customPayroll.amountBill }),
              ...(customPayroll.hoursBill !== undefined && { hoursBill: customPayroll.hoursBill }),

              ...(customPayroll.entryType === 'pay' &&
                customPayroll.headerInfo &&
                !existingEntry.payCode?.customPayrollTypeId && {
                  payCode: {
                    customPayrollTypeId: customPayroll.headerInfo.customPayrollTypeId,
                    reportTitle: customPayroll.headerInfo.title
                  }
                }),

              ...(customPayroll.entryType === 'bill' &&
                customPayroll.headerInfo &&
                !existingEntry.billingCode?.customPayrollTypeId && {
                  billingCode: {
                    customPayrollTypeId: customPayroll.headerInfo.customPayrollTypeId,
                    reportTitle: customPayroll.headerInfo.title
                  }
                }),

              // Siempre incluir ambos rates (mantener existente o usar del empleado)
              payRate: finalPayRate,
              billRate: finalBillRate,

              ...(employee.department && { department: employee.department }),
              ...(employee.position && { position: employee.position }),

              ...(customPayroll.modified !== undefined && { modified: customPayroll.modified })
            };

            updatedPayrollEntityList[existingIndex] = updatedEntry;
          } else {
            const newEntry = {
              id: employee.id,
              personId: employee.personId,
              employeeId: employee.employeeId,
              _idHeader: customPayroll._idHeader,
              payRate,
              billRate,
              department: employee.department,
              position: employee.position,

              ...(customPayroll.entryType === 'pay' &&
                customPayroll.headerInfo && {
                  payCode: {
                    customPayrollTypeId: customPayroll.headerInfo.customPayrollTypeId,
                    reportTitle: customPayroll.headerInfo.title
                  }
                }),
              ...(customPayroll.entryType === 'bill' &&
                customPayroll.headerInfo && {
                  billingCode: {
                    customPayrollTypeId: customPayroll.headerInfo.customPayrollTypeId,
                    reportTitle: customPayroll.headerInfo.title
                  }
                }),

              ...customPayroll
            };

            delete newEntry.headerInfo;
            updatedPayrollEntityList.push(newEntry);
          }
        });
      });

      return {
        ...state,
        payrollEntityList: updatedPayrollEntityList
      };
    }

    case customPayrollTypes.DELETE_HEADER_AND_RELATED_PAYROLL_ENTRIES: {
      const { _idHeader } = action.payload;

      const itemsToDelete = state.payrollEntityList.filter((item) => item._idHeader === _idHeader);

      const updatedPayrollEntityList = state.payrollEntityList.filter((item) => item._idHeader !== _idHeader);

      const itemsWithId = itemsToDelete.filter((item) => item.customPayrollId);

      return {
        ...state,
        payrollEntityList: updatedPayrollEntityList,
        deletedItems: [...state.deletedItems, ...itemsWithId]
      };
    }

    case customPayrollTypes.CHANGE_EMPLOYEE_VALUE: {
      const { id, key, value } = action.payload;
      let updatedPayrollList = state.payrollEntityList;

      if (key === 'position' && value) {
        const { payRate, billRate, department, position } = resolvePositionRatesAndRefs(value);

        updatedPayrollList = state.payrollEntityList.map((entry) => {
          if (entry.id === id || entry.personId === id) {
            return {
              ...entry,
              payRate,
              billRate,
              ...(department && { department }),
              ...(position && { position })
            };
          }
          return entry;
        });
      }

      return {
        ...state,
        payrollEntityList: updatedPayrollList,
        employeesInCustomPayroll: state.employeesInCustomPayroll.map((employee) => {
          if (employee.id === id) {
            const updatedEmployee = { ...employee };
            updatedEmployee[key] = value;
            if (key === 'position') {
              const { payRate, billRate, department, position } = resolvePositionRatesAndRefs(value);

              updatedEmployee.rate = payRate ?? updatedEmployee.rate;
              updatedEmployee.bill = billRate ?? updatedEmployee.bill;

              if (department) {
                updatedEmployee.department = department;
              }

              if (position) {
                updatedEmployee.position = position;
              }
            }
            return updatedEmployee;
          }
          return employee;
        })
      };
    }

    case customPayrollTypes.ADD_TO_DELETED_ITEMS: {
      const alreadyTracked = state.deletedItems.some((d) => d.customPayrollId === action.payload.customPayrollId);
      if (alreadyTracked) return state;
      return {
        ...state,
        deletedItems: [...state.deletedItems, action.payload]
      };
    }

    case customPayrollTypes.RESET_ENTIRE_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
